module.exports = __webpack_public_path__ + "static/media/foundation.386adee6.png";